import { FaUserGraduate } from "react-icons/fa";
import "./styles.css";
import { DownloadCertificadoButton } from "../../../pages/PageTrilhaNew/Certificado";
import { useTheme, useMediaQuery } from "@mui/material";

export default function Certificado({
  cursoConcluido,
  name,
  curso,
  cargaHoraria,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <div
      className="certificado_area"
      style={{ width: isMobile ? "50%" : "30%" }}
    >
      <h1>Certificado</h1>

      <div
        className="certificado-container"
        style={{ width: isMobile ? "180px" : "220px" }}
      >
        <div className="certificado-icon">
          <FaUserGraduate size={32} color="#555" />
        </div>
        <h4 className="certificado-titulo">Certificado</h4>
        <p className="certificado-subtitulo">Acesse agora o seu</p>
        {cursoConcluido ? (
          <DownloadCertificadoButton
            nome={name}
            curso={curso}
            cargaHoraria={cargaHoraria}
          />
        ) : (
          <button className="certificado-botao" disabled>
            Baixar
          </button>
        )}
      </div>
    </div>
  );
}
